/**
 * 施工事例 一覧 — フィルタ（横並びドロップダウン）+ AJAX 絞り込み
 *
 * 依存（functions.php で localize / inline 注入）:
 *   window.ArtecsWorksFilter      { ajaxUrl, nonce, action }
 *   window.ArtecsWorksLabels      { area_pref:{v:label}, gyoshu:{}, product:{} }
 *   window.ArtecsWorksGroupLabels { area_pref:'エリア', gyoshu:'業種', product:'商品' }
 */
(function () {
  'use strict';

  var GROUPS = ['area_pref', 'gyoshu', 'product'];

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ---- ドロップダウン開閉（PC） + SP アコーディオン -------------------- */
  function initDropdowns() {
    var dropdowns = Array.prototype.slice.call(document.querySelectorAll('[data-dropdown]'));

    dropdowns.forEach(function (dd) {
      var btn = dd.querySelector('.works-dropdown_btn');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = dd.classList.contains('is-open');
        dropdowns.forEach(function (other) {
          other.classList.remove('is-open');
          var b = other.querySelector('.works-dropdown_btn');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          dd.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // 外側クリックで閉じる
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-dropdown]')) return;
      dropdowns.forEach(function (dd) {
        dd.classList.remove('is-open');
        var b = dd.querySelector('.works-dropdown_btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });

    // SP フィルタ開閉トグル
    var bar = document.getElementById('works-filterbar');
    var toggle = bar ? bar.querySelector('.works-filter-toggle') : null;
    if (toggle && bar) {
      toggle.addEventListener('click', function () {
        var open = bar.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* ---- バッジのカウント更新 ------------------------------------------- */
  function updateCounts(filterForm) {
    GROUPS.forEach(function (g) {
      var checked = filterForm.querySelectorAll('input[name="' + g + '[]"]:checked').length;
      var dd = filterForm.querySelector('input[name="' + g + '[]"]');
      if (!dd) return;
      var btn = dd.closest('[data-dropdown]').querySelector('.works-dropdown_btn');
      if (btn) btn.setAttribute('data-count', String(checked));
    });
  }

  /* ---- AJAX 絞り込み --------------------------------------------------- */
  function initFilter() {
    if (!window.ArtecsWorksFilter) return;

    var filterForm  = document.getElementById('works-filter-form');
    var searchForm  = document.getElementById('works-search-form');
    var sortSelect  = document.getElementById('works-orderby');
    var resultsBody = document.getElementById('worksResultsBody');
    var countEl     = document.querySelector('.works-archive_count strong');
    var chipsEl     = document.getElementById('worksActiveFilters');
    if (!filterForm || !resultsBody) return;

    var currentPaged = 1;
    var inflight = null;

    function keyword() {
      if (!searchForm) return '';
      var sb = searchForm.querySelector('input[name="s"]');
      return sb ? sb.value.trim() : '';
    }

    function renderChips() {
      if (!chipsEl) return;
      var labelsAll = window.ArtecsWorksLabels || {};
      var html = '';
      var kw = keyword();
      if (kw) {
        html += '<button type="button" class="works-chip" data-clear-s>'
              + '<span>キーワード：' + escapeHtml(kw) + '</span><em>×</em></button>';
      }
      GROUPS.forEach(function (g) {
        var labels = labelsAll[g] || {};
        filterForm.querySelectorAll('input[name="' + g + '[]"]:checked').forEach(function (cb) {
          var v = cb.value;
          var decoded;
          try { decoded = decodeURIComponent(v); } catch (e) { decoded = v; }
          // labels マップは PHP 側でデコード済キーで構築済み。encoded/decoded 両方で照合し、
          // 見つからなければ slug を素表示せずデコード値を返す。
          var label = labels[v] || labels[decoded] || decoded;
          html += '<button type="button" class="works-chip" data-uncheck="' + g + '" data-value="' + escapeHtml(v) + '">'
                + '<span>' + escapeHtml(label) + '</span><em>×</em></button>';
        });
      });
      if (html) {
        html = '<span class="works-archive_chips-label">適用中：</span>' + html
             + '<button type="button" class="works-chip works-chip--clear" data-clear-all>すべて解除</button>';
      }
      chipsEl.innerHTML = html;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function collectFormData() {
      var fd = new FormData();
      fd.append('action', window.ArtecsWorksFilter.action);
      fd.append('nonce', window.ArtecsWorksFilter.nonce);
      fd.append('paged', String(currentPaged));
      new FormData(filterForm).forEach(function (v, k) { fd.append(k, v); });
      var kw = keyword();
      if (kw) { fd.delete('s'); fd.append('s', kw); }
      if (sortSelect && sortSelect.value && sortSelect.value !== 'new') {
        fd.delete('orderby'); fd.append('orderby', sortSelect.value);
      }
      return fd;
    }

    function syncUrl(fd) {
      var url = new URL(window.location.href);
      ['s', 'orderby', 'area_pref[]', 'gyoshu[]', 'product[]', 'paged'].forEach(function (k) {
        url.searchParams.delete(k);
      });
      var seen = {};
      fd.forEach(function (v, k) {
        if (k === 'action' || k === 'nonce') return;
        if (k === 'paged' && String(v) === '1') return;
        if (k === 'orderby' && v === 'new') return;
        if (k === 's' && !v) return;
        if (k.indexOf('[]') > -1) {
          url.searchParams.append(k, v);
        } else if (!seen[k]) {
          url.searchParams.set(k, v); seen[k] = true;
        }
      });
      history.replaceState(null, '', url.toString());
    }

    function applyFilter() {
      if (inflight) inflight.abort();
      inflight = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var fd = collectFormData();
      syncUrl(fd);
      renderChips();
      updateCounts(filterForm);
      resultsBody.setAttribute('aria-busy', 'true');
      resultsBody.classList.add('is-loading');

      fetch(window.ArtecsWorksFilter.ajaxUrl, {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        signal: inflight ? inflight.signal : undefined
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          resultsBody.classList.remove('is-loading');
          resultsBody.setAttribute('aria-busy', 'false');
          if (!res || !res.success) return;
          resultsBody.innerHTML = res.data.html;
          if (countEl) countEl.textContent = (res.data.count || 0).toLocaleString();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          resultsBody.classList.remove('is-loading');
          resultsBody.setAttribute('aria-busy', 'false');
        });
    }

    // チェックボックス変更
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]')) {
        currentPaged = 1;
        applyFilter();
      }
    });

    // 検索送信
    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        e.preventDefault();
        currentPaged = 1;
        applyFilter();
      });
    }
    filterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      currentPaged = 1;
      applyFilter();
    });

    // 並び替え
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        currentPaged = 1;
        applyFilter();
      });
    }

    // リセット
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.works-filterbar_reset');
      if (!a) return;
      e.preventDefault();
      filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
      if (searchForm) {
        var s = searchForm.querySelector('input[name="s"]');
        if (s) s.value = '';
      }
      if (sortSelect) sortSelect.value = 'new';
      currentPaged = 1;
      applyFilter();
    });

    // チップ操作
    if (chipsEl) {
      chipsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        if (btn.hasAttribute('data-clear-all')) {
          filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
          if (searchForm) { var sb = searchForm.querySelector('input[name="s"]'); if (sb) sb.value = ''; }
        } else if (btn.hasAttribute('data-clear-s')) {
          if (searchForm) { var sb2 = searchForm.querySelector('input[name="s"]'); if (sb2) sb2.value = ''; }
        } else if (btn.hasAttribute('data-uncheck')) {
          var g = btn.getAttribute('data-uncheck');
          var v = btn.getAttribute('data-value');
          var cb = filterForm.querySelector('input[name="' + g + '[]"][value="' + (window.CSS && CSS.escape ? CSS.escape(v) : v.replace(/"/g, '\\"')) + '"]');
          if (cb) cb.checked = false;
        }
        currentPaged = 1;
        applyFilter();
      });
    }

    // ページ送り（委譲）
    resultsBody.addEventListener('click', function (e) {
      var a = e.target.closest('.works-list_pagination a');
      if (!a) return;
      e.preventDefault();
      var m = a.getAttribute('href').match(/[?&]paged=(\d+)/);
      var txt = a.textContent.trim();
      if (m) {
        currentPaged = parseInt(m[1], 10) || 1;
      } else if (txt === '→') {
        currentPaged += 1;
      } else if (txt === '←') {
        currentPaged = Math.max(1, currentPaged - 1);
      } else {
        currentPaged = parseInt(txt, 10) || 1;
      }
      applyFilter();
      var results = document.querySelector('.works-archive_results');
      if (results) {
        var top = results.getBoundingClientRect().top + window.pageYOffset - 20;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });

    renderChips();
    updateCounts(filterForm);
  }

  ready(function () {
    initDropdowns();
    initFilter();
  });
})();
